import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { SerializedError } from '@reduxjs/toolkit';
import { BasicAlert, BasicAlertParams } from '@g17eco/molecules/alert';
import { getErrorMessage } from '../../utils/error';

interface QueryErrorProps extends Omit<BasicAlertParams, 'children' | 'type'> {
  error: FetchBaseQueryError | SerializedError;
  type?: BasicAlertParams['type'];
}

export const QueryError = (props: QueryErrorProps) => {
  const { error, type = 'danger', ...rest } = props;

  if (!error) {
    return null;
  }

  return <BasicAlert type={type} {...rest}>{getErrorMessage(error)}</BasicAlert>;
};
